/**
 * /settings/payments — the founder's money panel.
 *
 * TWO GATES, AND NEITHER IS THE OTHER'S BACKUP. VITE_PAYMENTS keeps the tab out of the
 * nav and redirects a direct URL hit, exactly like /settings/usage; the SERVER refuses the
 * route to anybody who is not the system founder, with the same body an id that names
 * nothing gets. The build flag is a UI convenience and decides nothing about access — a
 * bundle with the flag on still gets 404 from the gateway unless the caller is the
 * founder.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { env } from '../../../env';

export const Route = createFileRoute('/_authenticated/settings/payments')({
  beforeLoad: () => {
    if (!env.VITE_PAYMENTS) {
      throw redirect({ to: '/settings/profile', replace: true });
    }
  },
});
